import React from "react";

export const AccompagnementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none">
      <mask
        id="mask0_432_126"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="53"
        height="53">
        <path
          d="M30.4997 55.9173C33.8381 55.9215 37.1443 55.2659 40.2286 53.9883C43.3128 52.7108 46.1142 50.8363 48.4718 48.4728C50.8354 46.1152 52.7098 43.3138 53.9873 40.2295C55.2649 37.1453 55.9205 33.839 55.9164 30.5007C55.9205 27.1623 55.2649 23.856 53.9873 20.7718C52.7098 17.6876 50.8354 14.8862 48.4718 12.5285C46.1142 10.165 43.3128 8.29059 40.2286 7.01302C37.1443 5.73545 33.8381 5.07989 30.4997 5.084C27.1613 5.07989 23.8551 5.73545 20.7708 7.01302C17.6866 8.29059 14.8852 10.165 12.5276 12.5285C10.164 14.8862 8.28962 17.6876 7.01204 20.7718C5.73447 23.856 5.07891 27.1623 5.08303 30.5007C5.07891 33.839 5.73447 37.1453 7.01204 40.2295C8.28962 43.3138 10.164 46.1152 12.5276 48.4728C14.8852 50.8363 17.6866 52.7108 20.7708 53.9883C23.8551 55.2659 27.1613 55.9215 30.4997 55.9173Z"
          fill="white"
          stroke="white"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M30.5 36.3783V31.2949C32.0081 31.2949 33.4823 30.8477 34.7362 30.0099C35.9901 29.172 36.9675 27.9812 37.5446 26.5879C38.1217 25.1946 38.2727 23.6615 37.9785 22.1824C37.6843 20.7033 36.9581 19.3446 35.8917 18.2782C34.8253 17.2119 33.4667 16.4856 31.9876 16.1914C30.5085 15.8972 28.9753 16.0482 27.582 16.6253C26.1888 17.2025 24.9979 18.1798 24.16 19.4337C23.3222 20.6876 22.875 22.1618 22.875 23.6699"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.4993 47.8151C31.342 47.8151 32.1501 47.4804 32.7459 46.8846C33.3417 46.2887 33.6764 45.4806 33.6764 44.638C33.6764 43.7954 33.3417 42.9873 32.7459 42.3915C32.1501 41.7957 31.342 41.4609 30.4993 41.4609C29.6567 41.4609 28.8486 41.7957 28.2528 42.3915C27.657 42.9873 27.3223 43.7954 27.3223 44.638C27.3223 45.4806 27.657 46.2887 28.2528 46.8846C28.8486 47.4804 29.6567 47.8151 30.4993 47.8151Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_432_126)">
        <path d="M0 0H61V61H0V0Z" fill="#2481A6" />
      </g>
    </svg>
  );
};
